/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyboard_ShortcutsInputs */

const en_keyboard_shortcuts = /** @type {(inputs: Keyboard_ShortcutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyboard Shortcuts`)
};

const es_keyboard_shortcuts = /** @type {(inputs: Keyboard_ShortcutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atajos de teclado`)
};

const fr_keyboard_shortcuts = /** @type {(inputs: Keyboard_ShortcutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raccourcis clavier`)
};

const de_keyboard_shortcuts = /** @type {(inputs: Keyboard_ShortcutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tastenkombinationen`)
};

const ja_keyboard_shortcuts = /** @type {(inputs: Keyboard_ShortcutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キーボードショートカット`)
};

const zh_keyboard_shortcuts = /** @type {(inputs: Keyboard_ShortcutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`键盘快捷键`)
};

const ar_keyboard_shortcuts = /** @type {(inputs: Keyboard_ShortcutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اختصارات لوحة المفاتيح`)
};

const id_keyboard_shortcuts = /** @type {(inputs: Keyboard_ShortcutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pintasan Keyboard`)
};

const it_keyboard_shortcuts = /** @type {(inputs: Keyboard_ShortcutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scorciatoie da tastiera`)
};

const ru_keyboard_shortcuts = /** @type {(inputs: Keyboard_ShortcutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сочетания клавиш`)
};

const pt_keyboard_shortcuts = /** @type {(inputs: Keyboard_ShortcutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atalhos de teclado`)
};

const ko_keyboard_shortcuts = /** @type {(inputs: Keyboard_ShortcutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`키보드 단축키`)
};

/**
* | output |
* | --- |
* | "Keyboard Shortcuts" |
*
* @param {Keyboard_ShortcutsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const keyboard_shortcuts = /** @type {((inputs?: Keyboard_ShortcutsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyboard_ShortcutsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_keyboard_shortcuts(inputs)
	if (locale === "es") return es_keyboard_shortcuts(inputs)
	if (locale === "fr") return fr_keyboard_shortcuts(inputs)
	if (locale === "de") return de_keyboard_shortcuts(inputs)
	if (locale === "ja") return ja_keyboard_shortcuts(inputs)
	if (locale === "zh") return zh_keyboard_shortcuts(inputs)
	if (locale === "ar") return ar_keyboard_shortcuts(inputs)
	if (locale === "id") return id_keyboard_shortcuts(inputs)
	if (locale === "it") return it_keyboard_shortcuts(inputs)
	if (locale === "ru") return ru_keyboard_shortcuts(inputs)
	if (locale === "pt") return pt_keyboard_shortcuts(inputs)
	return ko_keyboard_shortcuts(inputs)
});